var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandardNoBrandLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148.345,
    height: 97.852,
    viewBox: "0 0 148.345 97.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.757,
    y1: 0.488,
    x2: 0.773,
    y2: 1.074,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4674e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9151e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.194,
    y1: -0.045,
    x2: 0.526,
    y2: 1.028,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#130803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130803",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.106,
    y1: 0.651,
    x2: 1.73,
    y2: 1.389,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1.269,
    y1: 0.71,
    x2: 1.903,
    y2: 1.594,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -0.385,
    y1: 0.947,
    x2: -0.818,
    y2: 0.022,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7743c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -0.512,
    y1: 0.912,
    x2: -1.332,
    y2: -0.197,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -1.463,
    y1: 1.127,
    x2: -1.148,
    y2: -0.348,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -108.717,
    y1: -1.477,
    x2: -108.592,
    y2: -0.917,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#76a021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe12f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.173,
    y1: 1.088,
    x2: 1.284,
    y2: 0.13,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8637b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#ff2224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb14e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -0.316,
    y1: 1.01,
    x2: 1.445,
    y2: -0.232,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.167,
    y1: 1.219,
    x2: 1.512,
    y2: 0.26,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 1.683,
    y1: 0.5,
    x2: 2.119,
    y2: 0.132,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.973,
    y1: 1.091,
    x2: 2.026,
    y2: 0.227,
    xlinkHref: "#c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-115.147 -173.987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.438,253.1c8.645,6.5,31.6,26.814,63.156,15.249a48.736,48.736,0,0,0,13.144-7,38.048,38.048,0,0,0,11.178-13.971c-10.48,6.472-19.4,4.615-25.931.8a33.108,33.108,0,0,1-5.062-3.655,38.978,38.978,0,0,1-3.5-3.451,61.788,61.788,0,0,1-22.123,10.1A89.56,89.56,0,0,1,120.438,253.1Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,251.168c22.859,14.045,37.054,13.756,45.438,10.177a38.048,38.048,0,0,0,11.178-13.971c-16.341,10.093-28.9-.068-34.493-6.306A61.8,61.8,0,0,1,151.3,251.168Z",
    opacity: 0.45,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.438,253.1c29.974,14.836,52.662,1.867,61.546-4.922a36.35,36.35,0,0,1-8.562-7.107,61.788,61.788,0,0,1-22.123,10.1A89.535,89.535,0,0,1,120.438,253.1Z",
    opacity: 0.35,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.438,253.1c24.309,7.649,47.153-3.13,56.483-8.578a38.978,38.978,0,0,1-3.5-3.451,61.788,61.788,0,0,1-22.123,10.1A89.535,89.535,0,0,1,120.438,253.1Z",
    opacity: 0.35,
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.139,227.385c1.236,1.454,2.916,3.357,4.82,5.309,3.833,3.913,8.562,8.013,12.409,9.033,3,.8,4.935.38,6.2-.441.917-2.332,1.767-4.672,2.673-6.972a.121.121,0,0,0,.018-.032c2.325-5.934,5.025-11.624,10.18-16.348,16.058-14.706,40.058-10.66,40.058-10.66-15.56-2.879-26.593-2.474-31.525-2.022a10.554,10.554,0,0,1-5.051-.8c-.758-.319-1.7-.9-2.844-1.516a.053.053,0,0,1-.019-.009,17.474,17.474,0,0,0-15.831-1.06c-8.928,3.443-9.195,8.339-15.712,18.232A90.183,90.183,0,0,1,187.139,227.385Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.139,227.385c1.236,1.454,2.916,3.357,4.82,5.309,4.055-7.636,6.741-17.229,12.328-23.772,8.705-10.186,19.243-6.2,19.765-5.995a17.474,17.474,0,0,0-15.831-1.06c-8.928,3.443-9.195,8.339-15.712,18.232A89.905,89.905,0,0,1,187.139,227.385Z",
    opacity: 0.38,
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.139,227.385c3.719,4.385,11.472,12.809,17.229,14.341,3,.8,4.935.38,6.2-.441.917-2.332,1.767-4.672,2.673-6.972-.474.7-8.116,11.146-20.727-14.215A89.731,89.731,0,0,1,187.139,227.385Z",
    opacity: 0.34,
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.278,234.2c-.231.654-.45,1.316-.669,1.978a9.4,9.4,0,0,0,.653-1.906C213.274,234.23,213.278,234.2,213.278,234.2Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.253,254.3c7.967,2.609,13.912,3.347,18.436,2.755h.007c8.607-1.117,12.076-7.008,14.568-13.833.844-2.294,1.573-4.69,2.344-7.047-1.771,3.8-7.732,9.977-25.552-11.295-11.546-13.779-23.65-26.776-35.3-36.179-8.233-6.659-16.239-11.525-23.659-13.6A27.426,27.426,0,0,0,119.667,174C100.306,174.707,147.6,244.581,177.253,254.3Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.76,188.707c18.5,24.063,27.284,60.74,41.484,63.9,9.057,2.01,14.217-3.775,17.021-9.378a35.267,35.267,0,0,0,3-8.953.513.513,0,0,0,.016-.072c-.231.654-.45,1.316-.669,1.978-1.771,3.8-7.732,9.977-25.552-11.295C175.51,211.107,163.406,198.11,151.76,188.707Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.253,254.3c7.967,2.609,13.912,3.347,18.436,2.755-.5.019-23.254.747-38.445-27.259-13.019-24.006-12.6-43.474-29.143-54.693A27.426,27.426,0,0,0,119.667,174C100.306,174.707,147.6,244.581,177.253,254.3Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.667,174a27.422,27.422,0,0,1,8.434,1.106c7.419,2.074,15.426,6.939,23.659,13.6a204.771,204.771,0,0,1,19.793,18.66c-2.335-2.123-4.661-4.132-6.968-5.995-8.233-6.659-16.239-11.525-23.659-13.6a27.426,27.426,0,0,0-8.434-1.106c-12.909.47,3.818,31.689,25.188,55.328C131.119,219.018,104.244,174.563,119.667,174Z",
    opacity: 0.35,
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.667,174a27.422,27.422,0,0,1,8.434,1.106c7.419,2.074,15.426,6.939,23.659,13.6,8.745,7.061,17.749,16.149,26.58,26.072a220.967,220.967,0,0,0-23.714-22.893c-8.233-6.659-16.239-11.525-23.659-13.6a27.426,27.426,0,0,0-8.434-1.106c-12.584.458,3,30.137,23.584,53.529C124.152,206.927,106.5,174.481,119.667,174Z",
    opacity: 0.35,
    fill: "url(#m)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardNoBrandLogo);
export default __webpack_public_path__ + "static/media/standardNoBrandLogo.495e503ab023bd000700b80cb05c8dfe.svg";
export { ForwardRef as ReactComponent };